import { SortDirection } from "@tanstack/react-table";
import classNames from "classnames";
import { Inline, Stack } from "PFComponents/containers";
import { DropdownOption } from "PFComponents/dropdown/dropdown";
import { Select } from "PFComponents/select/select";
import { Typography } from "PFComponents/typography";
import { RefObject, useState } from "react";
import { useTranslation } from "react-i18next";

import css from "../../../../parts/overview/detail_view/detail_view.module.scss";
import cssWarningsDetail from "./warning_detail.module.scss";

type WarningsDetailProps = {
  summary: string;
  customHeader?: React.ReactNode;
  children: (selectedSort: SortDirection) => React.ReactNode;
  sidePanelRef?: RefObject<HTMLDivElement | null>;
};

export const WarningsDetail = ({ summary, customHeader, children, sidePanelRef }: WarningsDetailProps) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "details.warnings" });

  const sortOptions: DropdownOption[] = [
    { id: "asc", displayElement: t("dateAsc"), item: "asc" },
    { id: "desc", displayElement: t("dateDesc"), item: "desc" }
  ];

  const [selectedSort, setSelectedSort] = useState<SortDirection>(sortOptions[0].item);

  return (
    <Stack className={classNames(css.root)} gap="spacingLg">
      <Stack gap="spacingLg">
        {customHeader}
        <Inline gap="spacingMd" alignItems="center">
          <Select
            className={cssWarningsDetail.select}
            controlledValue
            options={sortOptions}
            value={sortOptions.find(({ item }) => item === selectedSort)?.displayElement}
            onChange={(value: string) => setSelectedSort(value as SortDirection)}
            portalRef={sidePanelRef}
          />
          <Typography withMargin variant="labelRegular" className={css.subtitle}>
            {summary}
          </Typography>
        </Inline>
      </Stack>
      {children(selectedSort)}
    </Stack>
  );
};
